import {Column} from 'ag-grid-community';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Safely retrieves the header name from a column for use in filter placeholders.
 * Handles edge cases where column might be null during destruction or initialization.
 *
 * @param column - The AG Grid Column object (may be null in edge cases)
 * @returns The header name or null if unavailable
 */
export const getFilterFieldName = (column: Column | Nullish): string | Nullish => {
  if (isNil(column)) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('DataGrid: column is null when getting field name for filter');
    }
    return null;
  }

  const colDef = column.getColDef();

  if (isNil(colDef)) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('DataGrid: colDef is null when getting field name for filter');
    }
    return null;
  }

  return colDef.headerName ?? null;
};
